import { render, staticRenderFns } from "./SidebarSubmitOffer.vue?vue&type=template&id=61745c54&"
import script from "./SidebarSubmitOffer.vue?vue&type=script&lang=js&"
export * from "./SidebarSubmitOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports